export const WEBSERVER_URL = "https://api.snackpass.co/api/v4";
export const RIG_NAME = "Chicken_lp_RG_v5_EXPORT";
